'use strict'

Object.defineProperty(exports, '__esModule', { value: true })
exports.mapStudioApiProcessData = exports.mapCredentials = exports.STUDIO_API_ADAPTER = void 0
exports.STUDIO_API_ADAPTER = 'studio-api-adapter'
var mapCredentials = function (creds) {
  return ({
    accessKeyId: creds.data.attributes.accessKey,
    secretAccessKey: creds.data.attributes.secretKey,
    sessionToken: creds.data.attributes.sessionToken,
    expireTime: new Date(creds.data.attributes.expiration),
    keyPrefix: creds.data.attributes.keyPrefix,
    bucket: creds.data.attributes.bucket,
    region: creds.data.attributes.region,
    currentServerTime: creds.data.attributes.currentServerTime,
  })
}
exports.mapCredentials = mapCredentials
var mapStudioApiProcessData = function (key) {
  return ({
    data: {
      type: 'upload-process',
      attributes: {
        sourceKey: key,
      },
    },
  })
}
exports.mapStudioApiProcessData = mapStudioApiProcessData
//# sourceMappingURL=StudioApiAdaptor.js.map
